import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { TUserRoles } from '@/features/users/schemas/users.schema.ts';

interface AuthStore {
  refreshToken: {
    expiresAt: number | undefined;
  };
  setTokenExpiration: (unixDate: number) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (bool: boolean) => void;
  role: TUserRoles;
  setUserRole: (role: TUserRoles) => void;
  userId: string | undefined;
  setUserId: (userId: string) => void;
}

export const useAuthStore = create<AuthStore>()(
  devtools(
    persist(
      (set) => ({
        refreshToken: {
          expiresAt: undefined,
        },
        setTokenExpiration: (unixDate) =>
          set(() => ({
            refreshToken: { expiresAt: Number(unixDate) },
          })),
        isAuthenticated: false,
        setIsAuthenticated: (bool) => set(() => ({ isAuthenticated: bool })),
        role: 'Unknown',
        setUserRole: (role: TUserRoles) => set(() => ({ role })),
        userId: undefined,
        setUserId: (userId: string) => set(() => ({ userId })),
      }),
      { name: 'ems-auth-store' }
    )
  )
);

export const clearAuthStore = () => useAuthStore.persist.clearStorage();
